<template>
  <div class="mt-n4">
    <div class="d-flex align-center">
      <div>
        <v-btn
          fab
          text
          x-small
          color="white"
          @click="movePreviousMonth"
          :disabled="prevousDateIsLowerThanSpecificDate"
        >
          <v-icon large> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn
          fab
          text
          x-small
          color="white"
          @click="moveNextMonth"
          :disabled="nextDateIsGreaterThanToday"
        >
          <v-icon large> mdi-chevron-right </v-icon>
        </v-btn>
      </div>
      <div style="width: 170px">
        <v-select
          id="slect-month"
          v-model="month"
          class="select-style pl-2"
          dense
          outlined
          :items="months"
          background-color="secondary"
          item-color="accent"
          item-text="label"
          item-value="number"
          :item-disabled="isItemDisabled"
          :value="header.month.number"
          hide-details
        >
        </v-select>
      </div>
      <div style="width: 120px">
        <v-select
          class="select-style pl-2"
          dense
          v-model="year"
          outlined
          :items="yearLabels"
          background-color="secondary"
          item-color="accent"
          :value="year"
          hide-details
          @change="setToCurrentMonthIfGreater"
        >
        </v-select>
      </div>
      <v-spacer></v-spacer>
      <div>
        <v-progress-circular
          v-show="stationCalendarLoading"
          indeterminate
          color="accent"
        ></v-progress-circular>
      </div>
    </div>
    <div class="pt-3">
      <div class="weekdays">
        <div
          class="weekday"
          v-for="(weekday, index) in weekdays"
          :key="index"
          :class="{
            weekfirst: index == 0 ? true : false,
            weekend: weekday.number == 7 ? true : false,
          }"
        >
          {{ weekday.label_3 }}
        </div>
      </div>

      <div class="week" v-for="(week, index) in weeks" :key="index">
        <div
          class="day"
          :class="{
            selected: day.isSelected && !day.dragActive,
            afteroday: day.isAfterToday,
            notSelect: day.notSelect && !day.isSelected,
            'border-radius':
              index == 5 && day.weekday == 1 ? ' 0px 0px 0px 8px' : '',
            dragged: day.isDragged,
          }"
          v-for="(day, i) in week"
          :key="i"
          @click="selectDay(day)"
          @mouseenter="enterDay(day)"
          @mouseleave="$emit('leaveDay', day)"
        >
          <div class="day-check">
            <span class="font-style-day">
              {{ day['day'] }} {{ day.labelFirsDay.toLowerCase() }}</span
            >

            <v-simple-checkbox
              color="#F99741"
              :value="day.isSelected && !day.dragActive"
              @input="selectDay(day)"
            ></v-simple-checkbox>
          </div>

          <div class="d-flex justify-center" style="gap: 0px" v-if="listTelemetryData && !day.isAfterToday">
            <v-tooltip
              top
              color="#151723"
              v-if="
                listTelemetryData.find((item) => {
                  if (item.date == day.date2) {
                    return item.windGustAbove;
                  }
                })
              "
            >
              <template v-slot:activator="{on, attrs}">
                <div class="icon-legend" v-bind="attrs" v-on="on">
                  <v-icon small color="#B94D8A">icon-alertadis-wind</v-icon>
                </div>
              </template>
              <span>Acima de 55 km/h</span>
            </v-tooltip>

            <v-tooltip
              top
              color="#151723"
              v-if="
                listTelemetryData.find((item) => {
                  if (item.date == day.date2) {
                    return item.precAbove;
                  }
                })
              "
            >
              <template v-slot:activator="{on, attrs}">
                <div class="icon-legend" v-bind="attrs" v-on="on">
                  <v-icon small color="#3894AE">icon-alertadis-wi-rain</v-icon>
                </div>
              </template>
              <span>Acima de 40 mm</span>
            </v-tooltip>

            <v-tooltip
              top
              color="#151723"
              v-if="
                listTelemetryData.find((item) => {
                  if (item.date == day.date2) {
                    return item.minTempBelow;
                  }
                })
              "
            >
              <template v-slot:activator="{on, attrs}">
                <div class="icon-legend" v-bind="attrs" v-on="on">
                  <v-icon small color="#69BECD">$temperatureMin</v-icon>
                </div>
              </template>
              <span>Abaixo de 6ºC</span>
            </v-tooltip>

            <v-tooltip
              top
              color="#151723"
              v-if="
                listTelemetryData.find((item) => {
                  if (item.date == day.date2) {
                    return item.maxTempAbove;
                  }
                })
              "
            >
              <template v-slot:activator="{on, attrs}">
                <div class="icon-legend" v-bind="attrs" v-on="on">
                  <v-icon small color="#C37323">$temperatureMax</v-icon>
                </div>
              </template>
              <span>Acima de 34ºC</span>
            </v-tooltip>

            <v-tooltip
              top
              color="#151723"
              v-if="
                listTelemetryData.find((item) => {
                  if (item.date == day.date2) {
                    return item.lightning;
                  }
                })
              "
            >
              <template v-slot:activator="{on, attrs}">
                <div class="icon-legend" v-bind="attrs" v-on="on">
                  <v-icon small color="#3D8EBB">icon-alertadis-bolt</v-icon>
                </div>
              </template>
              <span>Ocorrência de raios</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
//import { snackbar } from "@/core/controller/snackbar_controller";
import historicalService from '@/api/forecast-api/historical.service';

export default {
  props: {
    typeHistoricalSelected: {
      type: Object,
    },

    dragSelection: {
      type: Object,
    },

    selectedDateRange: {
      type: Object,
    },

    selectedDate: {
      type: Date,
    },

    isTime: {
      type: Boolean,
    },

    filterSelected: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    daysInMonths: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    weekdayLabels: [
      'Domingo',
      'Segunda',
      'Terça',
      'Quarta',
      'Quinta',
      'Sexta',
      'Sabádo',
    ],
    monthLabels: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],

    today: new Date(),
    todayCamps: {
      year: null,
      month: null,
      day: null,
    },

    month: null,
    year: null,
    valueSelect: null,
    value: new Date(),
    yearLabels: [],
    valueRangeSelected: {
      start: null,
      end: null,
    },
    dragRange: null,

    listTelemetryData: [],

    week: [],
    stationCalendarLoading: false,
  }),
  created() {
    this.initializedate();
  },

  mounted() {
    if (this.typeHistoricalSelected.id == 1) {
      this.$emit('input', this.selectedDate);
    }
    this.yearLabels = this.createArrayOfYears(2022);
  },

  watch: {
    typeHistoricalSelected() {
      this.value = null;
    },
    normalizedDragRange(val) {
      // Any time drag changes, normalize it and emit 'drag' event
      this.$emit('drag', val ? {start: val.start, end: val.end} : null);
    },

    week(val) {
      this.fetchStationCalendar(val[0][0], val[val.length - 1][6]);
    },

    filterSelected() {
      this.listTelemetryData = [];
      this.fetchStationCalendar(
        this.weeks[0][0],
        this.weeks[this.weeks.length - 1][6],
      );
    },
  },
  methods: {
    createArrayOfYears(year) {
      const currentYear = new Date().getFullYear();
      if (year <= currentYear) {
        return [year, ...this.createArrayOfYears(year + 1)];
      }
      return [];
    },
    initializedate() {
      this.todayCamps.year = this.today.getFullYear();
      this.todayCamps.month = this.today.getMonth() + 1;
      this.todayCamps.day = this.today.getDate();
      this.month = this.todayCamps.month;
      this.year = this.todayCamps.year;

      this.valueRangeSelected.start = new Date(
        moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
      );
      this.valueRangeSelected.end = new Date(
        moment().format('YYYY-MM-DD HH:mm'),
      );
    },

    moveThisMonth() {
      this.month = this.todayCamps.month;
      this.year = this.todayCamps.year;
    },
    moveNextMonth() {
      const {month, year} = this.nextMonthComps;

      this.month = month;
      this.year = year;
    },
    movePreviousMonth() {
      const {month, year} = this.previousMonthComps;
      this.month = month;
      this.year = year;
    },
    moveNextYear() {
      this.year++;
    },
    movePreviousYear() {
      this.year--;
    },
    async configureDay(day) {
      if (this.typeHistoricalSelected.id == 0 || this.isTime == true) {
        const date = moment(this.selectedDate).format('YYYY-MM-DD');
        day.isSelected = moment(day.date2).isSame(date);
        return;
      }

      const dateTime = day.date.getTime();
      const valueRange = this.normalizedValue;
      const dragRange = this.normalizedDragRange;
      day.isSelected =
        valueRange &&
        dateTime >= valueRange.startTime &&
        dateTime <= valueRange.endTime;
      day.startsSelection = valueRange && dateTime === valueRange.startTime;
      day.endsSelection = valueRange && dateTime === valueRange.endTime;
      day.dragActive = dragRange; // Just to let day know drag is happening somewhere
      day.isDragged =
        dragRange &&
        dateTime >= dragRange.startTime &&
        dateTime <= dragRange.endTime;
      day.startsDrag = dragRange && dateTime === dragRange.startTime;
      day.endsDrag = dragRange && dateTime === dragRange.endTime;
    },

    selectDay(day) {
      if (this.typeHistoricalSelected.id == 0) {
        this.$emit('input', day.isSelected ? this.selectedDate : day.date);
        return;
      }

      if (this.typeHistoricalSelected.id == 1 && this.isTime == true) {
        this.$emit('input', day.isSelected ? this.selectedDate : day.date);
        return;
      }

      // Start new drag selection if not dragging
      if (!this.dragRange) {
        this.dragRange = {
          start: day.date,
          end: day.date,
        };
        // Complete drag selection
      } else {
        if (
          this.calculateTimeDifferenceDates(
            this.dragRange.start,
            this.dragRange.end,
          ) > 6
        ) {
          const {end} = this.normalizedDragRange;

          const enDay = moment(end).hour('00:00').format('YYYY-MM-DD HH:mm');

          this.valueRangeSelected.start = new Date(
            moment(enDay).subtract(6, 'days').format('YYYY-MM-DD HH:mm'),
          );
          this.valueRangeSelected.end = end;
          const start = this.valueRangeSelected.start;

          this.dragRange = null;
          this.$emit('input', {start, end});

          return;
        }

        const {start, end} = this.normalizedDragRange;
        this.valueRangeSelected = this.dragRange;
        // Clear drag selection
        this.dragRange = null;
        // Signal new value selected on drag complete
        this.$emit('input', {start, end});
      }
    },
    enterDay(day) {
      if (!this.dragRange) return;
      // Update drag selection

      if (
        this.calculateTimeDifferenceDates(
          this.dragRange.start,
          this.dragRange.end,
        ) > 6
      ) {
        return;
      }
      this.dragRange = {
        start: this.dragRange.start,
        end: day.date,
      };

      this.calculateTimeDifferenceDates(
        this.dragRange.start,
        this.dragRange.end,
      );
    },

    normalizeRange(range) {
      if (!range) return null;
      const {start, end} = range;
      const startTime = start.getTime();
      const endTime = end.getTime();
      const isNormal = start < end;
      return {
        start: isNormal ? start : end,
        startTime: isNormal ? startTime : endTime,
        end: isNormal ? end : start,
        endTime: isNormal ? endTime : startTime,
      };
    },

    calculateTimeDifferenceDates(startDate, endDate) {
      const isNormal = startDate < endDate;

      const differenceInTime = isNormal
        ? endDate.getTime() - startDate.getTime()
        : startDate.getTime() - endDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);
      return differenceInDays;
    },

    async fetchStationCalendar(dayInit, dayEnd) {
      let id = this.filterSelected.location.id;

      if (dayEnd.isAfterToday) {
        dayEnd.date2 = moment().format('YYYY-MM-DD');
      }
      this.stationCalendarLoading = true;
      try {
        const summaryPayload = {
          startDate: dayInit.date2,
          endDate: dayEnd.date2,
          regionalId: id
        };

        const summaryResponse = await historicalService.getRegionalDailySummary(summaryPayload);

        let lightningByDate = {};

        try {
          const lightningPayload = {
            start_date: dayInit.date2,
            end_date: dayEnd.date2,
            regionalIds: [id]
          };

          const lightningResponse = await historicalService.getDailyLightningCountRegional(lightningPayload);

          if (lightningResponse.data && Array.isArray(lightningResponse.data)) {
            lightningResponse.data.forEach(item => {
              const hasLightning = (item.sumRegional || 0) > 0;
              lightningByDate[item.date] = hasLightning;
            });
          }

        } catch (lightningError) {
          lightningByDate = {};
        }

        if (!summaryResponse.data || !Array.isArray(summaryResponse.data)) {
          throw new Error('Resposta do DailySummary inválida');
        }

        this.listTelemetryData = summaryResponse.data.map(item => {
          const date = item.date || item.data;

          return {
            date: date,
            windGustAbove: (item.windGust || 0) > 55,  
            precAbove: (item.accumPrec || 0) > 40,         
            minTempBelow: (item.minTemp || 999) < 6,    
            maxTempAbove: (item.maxTemp || 0) > 34,      
            lightning: lightningByDate[date] || false
          };
        });

      } catch (error) {
        this.listTelemetryData = [];
      } finally {
        this.stationCalendarLoading = false;
      }
    },
    setToCurrentMonthIfGreater() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      if (this.year === currentYear && this.month > currentMonth) {
        this.month = currentMonth;
      }
      if (this.year === 2022 && this.month < 10) {
        this.month = 10;
      }
    },
    isItemDisabled(item) {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      if (this.year <= 2022) {
        return item.number < 10;
      }
      if (this.year >= currentYear) return item.number > currentMonth + 1;
    },
  },

  computed: {
    normalizedValue() {
      return this.normalizeRange(this.valueRangeSelected);
    },
    normalizedDragRange() {
      return this.normalizeRange(this.dragRange);
    },
    /* eslint-disable */
    hasValue() {
      if (this.typeHistoricalSelected.id == 0) {
        return (
          this.selectedDate && typeof this.selectedDate.getTime === 'function'
        );
      }
    },

    valueTime() {
      if (this.typeHistoricalSelected.id == 0) {
        return this.hasValue ? this.selectedDate.getTime() : null;
      }

      /*    if (!this.hasValues) return [];
      return this.valueArray.map((v) => v.getTime()); */
    },
    // Our component exposes month as 1-based, but sometimes we need 0-based
    monthIndex() {
      return this.month - 1;
    },

    isLeapYear() {
      return (
        (this.year % 4 === 0 && this.year % 100 !== 0) || this.year % 400 === 0
      );
    },

    // Day/month/year components for previous month
    previousMonthComps() {
      if (this.month === 1)
        return {
          days: this.daysInMonths[11],
          month: 12,
          year: this.year - 1,
        };
      return {
        days:
          this.month === 3 && this.isLeapYear
            ? 29
            : this.daysInMonths[this.month - 2],
        month: this.month - 1,
        year: this.year,
      };
    },

    // Day/month/year components for next month
    nextMonthComps() {
      if (this.month === 12)
        return {
          days: this.daysInMonths[0],
          month: 1,
          year: this.year + 1,
        };
      return {
        days:
          this.month === 2 && this.isLeapYear
            ? 29
            : this.daysInMonths[this.month],
        month: this.month + 1,
        year: this.year,
      };
    },

    // State for calendar header (no dependencies yet...)
    months() {
      return this.monthLabels.map((ml, i) => ({
        label: ml,
        label_1: ml.substring(0, 1),
        label_2: ml.substring(0, 2),
        label_3: ml.substring(0, 3),
        number: i + 1,
      }));
    },

    // State for weekday header (no dependencies yet...)
    weekdays() {
      return this.weekdayLabels.map((wl, i) => ({
        label: wl,
        label_1: wl.substring(0, 1),
        label_2: wl.substring(0, 2),
        label_3: wl.substring(0, 3).toLocaleUpperCase(),
        number: i + 1,
      }));
    },

    header() {
      const month = this.months[this.monthIndex];

      return {
        month: month,
        year: this.year.toString(),
        shortYear: this.year.toString().substring(2, 4),
        label: month.label + ' ' + this.year,
      };
    },

    // Returns number for first weekday (1-7), starting from Sunday
    firstWeekdayInMonth() {
      return new Date(this.year, this.monthIndex, 1).getDay() + 1;
    },

    daysInMonth() {
      // Check for February in a leap year
      if (this.month === 2 && this.isLeapYear) return 29;
      // ...Just a normal month
      return this.daysInMonths[this.monthIndex];
    },

    weeks() {
      const weeks = [];

      let previousMonth = true,
        thisMonth = false,
        nextMonth = false;

      let day = this.previousMonthComps.days - this.firstWeekdayInMonth + 2;
      let month = this.previousMonthComps.month;
      let year = this.previousMonthComps.year;

      for (let w = 1; w <= 6 && !nextMonth; w++) {
        const week = [];
        for (let d = 1; d <= 7; d++) {
          if (previousMonth && d >= this.firstWeekdayInMonth) {
            // Reset day/month/year counters
            day = 1;
            month = this.month;
            year = this.year;
            // ...and flag we're tracking actual month days
            previousMonth = false;
            thisMonth = true;
          }

          let dayFormat = day;
          let monthFormat = month;

          if (dayFormat < 10) {
            dayFormat = `0${day}`;
          }

          if (month < 10) {
            monthFormat = `0${month}`;
          }
          let format1 = `${year}-${monthFormat}-${dayFormat}`;

          const dateFomat = moment(format1).format('YYYY-MM-DD');

          const today = moment().format('YYYY-MM-DD');

          //      const telemetryData =  await this.fetchStationCalendar(dateFomat)

          const dayInfo = {
            label: day && thisMonth ? day.toString() : '',
            day,
            weekday: d,
            week: w,
            month,
            year,
            date2: dateFomat,
            date: new Date(year, month - 1, day),
            beforeMonth: previousMonth,
            afterMonth: nextMonth,
            inMonth: thisMonth,
            isToday:
              day === this.todayCamps.day &&
              month === this.todayCamps.month &&
              year === this.todayCamps.year,
            isFirstDay: thisMonth && day === 1,
            isLastDay: thisMonth && day === this.daysInMonth,
            isAfterToday: moment(dateFomat).isAfter(today),
            // telemetryData: telemetryData,
          };
          dayInfo.labelFirsDay = dayInfo.isFirstDay
            ? this.months[month - 1].label_3
            : '';
          ('');
          this.configureDay(dayInfo);
          week.push(dayInfo);

          if (thisMonth && day >= this.daysInMonth) {
            thisMonth = false;
            nextMonth = true;
            day = 1;
            month = this.nextMonthComps.month;
            year = this.nextMonthComps.year;
            // Still in the middle of the month (hasn't ended yet)
          } else {
            day++;
          }
        }
        weeks.push(week);
      }

      this.week = weeks;
      return weeks;
    },
    nextDateIsGreaterThanToday() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      if (this.year >= currentYear && this.month >= currentMonth) {
        return true;
      }
      return false;
    },
    prevousDateIsLowerThanSpecificDate() {
      //this date has been chosen by Product Owner
      const specificYear = 2022;
      const specificMonth = 10;
      if (this.year <= specificYear && this.month <= specificMonth) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="sass" scoped>
.calendar
  display: flex
  flex-direction: column
  align-items: flex-start
  padding: 0px
  gap: 8px
  isolation: isolate
  width: 900px
  height: 578px
.weekdays
  display: flex
  flex-direction: row
  align-items: flex-start
  padding: 0px
  width: 774px
  height: 42px
  background: #1b1f2d
  border-radius: 8px 0px 0px 0px
  font-family: "Manrope"
  font-style: normal
  font-weight: 500
  font-size: 14px
  line-height: 18px
  /* identical to box height, or 129% */

  letter-spacing: 0.75px

  /* UI Cinza/UI Cinza 0 */

  color: #ffffff

.weekday
  /* Auto layout */

  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: flex-start
  padding: 12px
  gap: 10px
  width: 100.57px
  height: 42px
  background: #151723
  border: 1px solid #828D9E
  flex: none
  align-self: stretch
  flex-grow: 1

.week
  display: flex
  flex-direction: row
  align-items: flex-start
  padding: 0px
  width: 700px
  height: 100px
  flex: none
  order: 1
  flex-grow: 0
.weekfirst
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: flex-start
  padding: 12px
  gap: 10px
  width: 100.57px
  height: 42px
  background: #151723
  border: 1px solid #828D9E
  border-radius: 8px 0px 0px 0px

.weekend
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: flex-start
  padding: 12px
  gap: 10px
  width: 100.57px
  height: 42px
  background: #151723
  border: 1px solid #828D9E
  border-radius: 0px 8px 0px 0px
.day
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: flex-start
  padding: 12px
  gap: 10px
  width: 110.57px
  height: 100px
  background: #151723
  border: 1px solid #828D9E
  flex: none
  align-self: stretch

.today
  color: white
  background-color: rgba(255, 173, 101, 0.05)

.day-check
  display: flex
  flex-direction: row
  justify-content: space-between
  align-items: center
  padding: 0px
  width: 90.57px
  height: 20px

.check
  box-sizing: border-box
  background-color: #151723
  accent-color: #F99741
  border: 1px solid #828D9E
  border-radius: 4px

.selected
  background-color: rgba(255, 173, 101, 0.05)
  color: #F99741

.dragged
  background-color: rgba(255, 173, 101, 0.05)
  color: #F99741
.font-style-day
  font-family: 'Manrope'
  font-style: normal
  font-weight: 500
  font-size: 14px
  line-height: 18px
  letter-spacing: 0.75px
  color: #828D9E

.afteroday
  pointer-events: none

.notSelect
  pointer-events: none

.select
  display: flex
  flex-direction: row
  align-items: center
  padding: 4px
  gap: 4px
  width: 88px
  height: 24px
  border-radius: 4px
  order: 1

#slect-month
  border-radius: 4px

.table
  border-radius: 8px
.v-select__selection--comma
  font-size: 13px

.icon-legend
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  padding: 0px
  width: 24px
  height: 24px
  background: linear-gradient(0deg, rgba(135, 55, 100, 0.1), rgba(135, 55, 100, 0.1)), rgba(255, 255, 255, 0.95)
  border: 1px solid #FFFFFF
  border-radius: 50px
</style>
